<template>
    <div class="user-block">
        <div v-if="showDefault">
            <!--            v-if="$userIsSuperAdmin()"-->
            Using default fees <a v-if="$userIsSuperAdmin()" @click.stop="setCustom">(customise)</a>
            <template v-if="modelData.text_array && modelData.text_array.length">
                <div v-for="txt in modelData.text_array">{{ txt }}</div>
            </template>
        </div>
        <div v-else>
            <template v-if="modelData">
                <a v-if="user && $userIsSuperAdmin()" href="#!" @click.stop="setDefault">(switch to default profile)</a>
                <div class="form-row user-block">
                    <b-form-group class="col-md-6" label="Shipping">
                        <b-form-input :disabled="!$userIsSuperAdmin()" :class="{'border bg-white':!$userIsSuperAdmin()}"
                                      class="w-100" type="number" :id="getId('shipping')" v-model="modelData.shipping"/>
                    </b-form-group>
                    <b-form-group class="col-md-6" label="Shipping GST">
                        <b-form-input :disabled="!$userIsSuperAdmin()" :class="{'border bg-white':!$userIsSuperAdmin()}"
                                      class="w-100" type="number" :id="getId('shipping_gst')"
                                      v-model="modelData.shipping_gst"/>
                    </b-form-group>
                </div>
                <div class="form-row user-block">
                    <b-form-group class="col-md-6" label="Other">
                        <b-form-input :disabled="!$userIsSuperAdmin()" :class="{'border bg-white':!$userIsSuperAdmin()}"
                                      class="w-100" type="number" :id="getId('other')" v-model="modelData.other"/>
                    </b-form-group>
                    <b-form-group class="col-md-6" label="Brokerage">
                        <b-form-input :disabled="!$userIsSuperAdmin()" :class="{'border bg-white':!$userIsSuperAdmin()}"
                                      class="w-100" type="number" :id="getId('brokerage')"
                                      v-model="modelData.brokerage"/>
                    </b-form-group>
                </div>
                <div class="form-row user-block" v-if="!user">
                    <b-form-group class="col-md-6" label="Bunker">
                        <b-form-input :disabled="!$userIsSuperAdmin()" :class="{'border bg-white':!$userIsSuperAdmin()}"
                                      class="w-100" type="number" :id="getId('bunker')" v-model="modelData.bunker"/>
                    </b-form-group>
                    <b-form-group class="col-md-6" label="Stink Bug">
                        <b-form-input :disabled="!$userIsSuperAdmin()" :class="{'border bg-white':!$userIsSuperAdmin()}"
                                      class="w-100" type="number" :id="getId('stink_bug')"
                                      v-model="modelData.stink_bug"/>
                    </b-form-group>
                </div>
                <div class="form-row agent-fees user-block">
                    <b-form-group class="col-md-12" label="Agent fees">
                        <template v-if="modelData.agent_fees">
                            <template v-for="(agent_fee, index) in modelData.agent_fees">
                                <div class="row mb-3 align-items-center">
                                    <div class="col-2 col-sm-2">{{ agent_fee.price_min }}</div>
                                    <div class="col-1 col-sm-1">-</div>
                                    <div class="col-4 col-sm-3">
                                        <b-form-input
                                            :disabled="!$userIsSuperAdmin()"
                                            type="number"
                                            placeholder="max"
                                            :class="{'border bg-white':!$userIsSuperAdmin()}" class="w-100"
                                            :state="rangeFieldState(index)"
                                            :id="getId('agent_fees'+index+'price_max')"
                                            v-model.number="modelData.agent_fees[index].price_max"
                                            @input="onMaxInput(index, $event)"/>
                                    </div>
                                    <div class="col-1 col-sm-1 text-center">=</div>
                                    <div class="col-4 col-sm-3">
                                        <b-form-input :class="{'border bg-white':!$userIsSuperAdmin()}" class="w-100"
                                                      type="number" placeholder="fee"
                                                      :disabled="!$userIsSuperAdmin()"
                                                      :id="getId('agent_fees'+index+'fee')"
                                                      :state="modelData.agent_fees[index].fee > 0 ? null : false"
                                                      v-model.number="modelData.agent_fees[index].fee"
                                                      @input="onInput"/>
                                    </div>
                                    <div class="col-12 col-sm-2 text-md-right">
                                        <b-btn :disabled="!$userIsSuperAdmin()" class="btn mt-2 mt-sm-0"
                                               @click="removeAgentRow(index)">Remove
                                        </b-btn>
                                    </div>
                                </div>
                                <div v-if="rangeFieldState(index) === false" class="row align-items-center">
                                    <div class="alert alert-danger">
                                        <div v-for="err in rangeFieldError(index)">- {{ err }}</div>
                                    </div>
                                </div>
                            </template>
                            <b-btn :disabled="!$userIsSuperAdmin()" class="btn mt-2 mt-sm-0" @click="addAgentRow">Add
                                new row
                            </b-btn>
                        </template>
                        <div class="row">
                            <b-form-group class="col-md-4" label="Increase agent fee by">
                                <b-form-input :disabled="!$userIsSuperAdmin()"
                                              :class="{'border bg-white':!$userIsSuperAdmin()}" class="w-100"
                                              type="number" :id="getId('agent_fee_step_value')"
                                              v-model.number="modelData.agent_fee_step_value" @input="onInput"/>
                            </b-form-group>
                            <b-form-group class="col-md-4" label="every">
                                <b-form-input :disabled="!$userIsSuperAdmin()"
                                              :class="{'border bg-white':!$userIsSuperAdmin()}" class="w-100"
                                              type="number" :id="getId('agent_fee_step')"
                                              v-model.number="modelData.agent_fee_step" @input="onInput"/>
                            </b-form-group>
                            <b-form-group class="col-md-4" label="yen for bids over">
                                <b-form-input :disabled="!$userIsSuperAdmin()"
                                              :class="{'border bg-white':!$userIsSuperAdmin()}" class="w-100"
                                              type="number" :id="getId('agent_fee_step_after')"
                                              v-model.number="modelData.agent_fee_step_after" @input="onInput"/>
                            </b-form-group>
                        </div>
                    </b-form-group>
                </div>
            </template>
        </div>
    </div>
</template>
<script>
import {mapState, mapActions} from 'vuex'
import {splitObjKey, objLookup, getExceptionErrorMessage, getHttpValidationErrors} from '../../util/common'

import BootstrapValidation from '../../mixins/bootstrap-validation';

export default {
    props: [
        'value',
        'user' //if set, then we don't show the bunker (comes from the default one, which is set on the admin page)
    ],
    mixins: [BootstrapValidation],
    data() {
        return {
            modelData: null,
            modelDataEmit: null,
            addAgentFeeRow: {
                min: null,
                max: null,
                fee: null,
            },
            rangeInvalidFeedback: 'This range must be greater than the previous',
        }
    },
    created() {
        this.modelData = this.value || {};
        this.modelDataEmit = this.value || {};
        if (this.modelData && this.modelData.agent_fees && this.modelData.agent_fees.length) {
            this.addAgentFeeRow.min = this.modelData.agent_fees[this.modelData.agent_fees.length - 1].price_max;
        }
    },
    computed: {
        showDefault() {
            if (!this.user) {
                return false;  //this means it's the default one on the admin settings page
            }
            if (this.isCustom === true) {
                return false;
            } else if (this.isCustom === false) {
                return true;
            }
            return !this.value || this.value.name === 'default'
        },
        isCustom() {
            if (this.value && this.value.id !== this.defaultPricing.id) {
                return true
            }
            return false
        }
    },
    methods: {
        onMaxInput(index, e) {
            if (index < this.modelData.agent_fees.length - 1) {
                this.modelData.agent_fees[index + 1].price_min = this.modelData.agent_fees[index].price_max;
            } else {
                this.addAgentFeeRow.min = this.modelData.agent_fees[index].price_max;
            }
            this.emitInput();
        },
        getId(name) {
            return name;
        },
        setDefault() {
            this.modelData.id = this.defaultPricing.id
            this.emitInput();
        },
        setCustom() {
            this.modelData.id = null
            this.emitInput();
        },
        onInput() {
            this.emitInput();
        },
        removeAgentRow(index) {
            let fees = [];
            this.modelData.agent_fees.forEach((fee, i) => {
                if (i !== index) {
                    fees.push(fee);
                }
            });
            let last;
            fees.forEach((fee, i) => {
                if (last) {
                    fee.price_min = last.price_max;
                } else {
                    fee.price_min = 0;
                }
                last = fee;
            });

            this.modelData.agent_fees = fees;
            this.emitInput();
        },
        addAgentRow() {
            const last_index = this.modelData.agent_fees.length - 1
            const price_min = this.modelData.agent_fees[last_index] ? this.modelData.agent_fees[last_index].price_max : 0
            const fee = this.modelData.agent_fees[last_index] ? this.modelData.agent_fees[last_index].fee : 92000
            this.modelData.agent_fees.push({
                price_min,
                price_max: null,
                fee,
            });
            this.emitInput();
        },
        emitInput() {
            let valid = true;
            this.modelData.agent_fees.forEach((fee, index) => {
                if (this.rangeFieldState(index) !== null) {
                    valid = false;
                }
            });
            if (valid) {
                this.modelDataEmit = this.modelData;
            }
            this.$emit('input', this.modelDataEmit);
        },
        rangeFieldState(index) {
            const error = this.rangeFieldError(index)
            if (!error.length) {
                return null
            }
            return false
        },

        rangeFieldError(index) {
            const last_index = this.modelData.agent_fees.length - 1
            const current = this.modelData.agent_fees[index]
            const prev = this.modelData.agent_fees[index - 1]
            const next = this.modelData.agent_fees[index + 1]
            const errors = []
            if (last_index !== index && !current.price_max) {
                errors.push('Please enter a range')
            }
            if (current && !current.fee) {
                errors.push('The fee cannot be empty')
            } else {
                if (prev && current.fee === prev.fee) {
                    errors.push('This row is redundant, the fee is the same as previous')
                }
            }
            if (current && current.price_min && current.price_max && current.price_max <= current.price_min) {
                errors.push('This value must be greater than the previous one')
            }
            if (prev && current.price_min - prev.price_max > 1) {
                errors.push('There is a gap between the min and max of the 2 highlights rows')
            }
            if (last_index === index && current.price_max) {
                errors.push('The last row must be empty. Add a new row or make it empty')
            }
            if (next && next.price_min && current.price_max && current.price_max > next.price_min) {
                errors.push('This value must be equal to the next row. Please adjust to fix it.')
            }
            return errors
        }


    }
}
</script>



// WEBPACK FOOTER //
// resources/js/components/User/Fees.vue